import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    let formId = this.element.id;
    // var form = document.getElementById(formId);

    (function ($, formId) {
      var $form = $('#' + formId);
      let disclaimers = $form.find('.tcpa-disclosure');
      let name_suffix = disclaimers.length > 1 ? '[]' : '';
      disclaimers.each(function () {
        // Get the innerHTML of the div, remove HTML tags, asterisk, newline characters, extra spaces and trim
        let text = $(this).text().replace(/(<([^>]+)>)/gi, "").replace('*', "").replace(/\r?\n|\r/g, " ").replace(/\s\s+/g, " ").trim();
        if (text !== '') {
          const parser = new DOMParser();
          let dom = parser.parseFromString(text, 'text/html');
          let body = dom.body;
          text = $(body).text();
        }

        // Create SHA-256 hash using CryptoJS
        const hash = CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex);

        // uncomment below for testing
        // console.log(text);
        // alert('here is my hash: ' + hash);

        // Get the form on the page
        const form = $form[0];
        // Create hidden input field, set its name and value, and append to the form
        if (form !== null) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = '_certificationUri' + name_suffix;
          input.value = hash;

          // Add data-related-classes attribute to the input field for identification purposes
          let classStr = $(this).attr('class');
          let parentClassStr = $(this).parent().attr('class');
          input.setAttribute('data-related-classes', classStr + ' ' + parentClassStr);

          form.appendChild(input);

          const input2 = document.createElement('input');
          input2.type = 'hidden';
          input2.name = '_certificationText' + name_suffix;
          input2.value = text;

          // Add data-related-classes attribute to the input2 field for identification purposes
          let classStr2 = $(this).attr('class');
          let parentClassStr2 = $(this).parent().attr('class');
          input2.setAttribute('data-related-classes', classStr2 + ' ' + parentClassStr2);

          form.appendChild(input2);
        }
      });
    })(jQuery, formId);
  }
}
